import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "overflow-x-auto" }
const _hoisted_3 = { class: "align-middle inline-block min-w-full" }
const _hoisted_4 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_5 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_6 = { class: "bg-gray-50" }
const _hoisted_7 = {
  key: 0,
  scope: "col",
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}, " Type ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}, " From ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}, " To ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}, " First/Last day hours ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}, " Open absence ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  width: "50px",
  style: {"min-width":"50px"},
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500"
}, " Actions ", -1)
const _hoisted_14 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "100%",
  class: "px-3 py-2 text-gray-500 text-sm"
}, "No absences found.", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "px-3 py-2 border-r text-sm"
}
const _hoisted_19 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_20 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_21 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_22 = ["set"]
const _hoisted_23 = { class: "inline-flex items-center justify-center" }
const _hoisted_24 = {
  title: "First Day",
  class: "text-xs font-semibold text-center px-1.5 py-1 rounded-md text-green-600 bg-green-100"
}
const _hoisted_25 = {
  key: 0,
  class: "mx-1.5"
}
const _hoisted_26 = {
  key: 1,
  title: "Last Day",
  class: "text-xs font-semibold text-center px-1.5 py-1 rounded-md text-green-600 bg-green-100"
}
const _hoisted_27 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "px-3 py-2 flex align-middle justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PencilIcon = _resolveComponent("PencilIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", _hoisted_6, [
              _createElementVNode("tr", null, [
                (_ctx.includeNameColumn)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_7, " Contract "))
                  : _createCommentVNode("", true),
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                _hoisted_13
              ])
            ]),
            _createElementVNode("tbody", _hoisted_14, [
              (_ctx.absences.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, _hoisted_17))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.absences, (absence) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: absence.id,
                  class: "hover:bg-gray-50"
                }, [
                  (_ctx.includeNameColumn)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                        _createElementVNode("span", null, _toDisplayString(absence.contract.person.surname) + " " + _toDisplayString(absence.contract.person.name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("span", null, _toDisplayString(absence.absenceType.name), 1)
                  ]),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(absence.dateFrom)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(absence.dateTo)), 1)
                  ]),
                  _createElementVNode("td", {
                    class: "px-3 py-2 border-r text-sm",
                    set: _ctx.absenceHours = _ctx.getAbsenceHours(absence)
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.absenceHours.firstDay), 1),
                      (_ctx.absenceHours.lastDay)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "/"))
                        : _createCommentVNode("", true),
                      (_ctx.absenceHours.lastDay)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.absenceHours.lastDay), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_22),
                  _createElementVNode("td", _hoisted_27, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["inline-flex items-center justify-center text-xs font-semibold text-center p-1 uppercase rounded-md", absence.open ? 'text-yellow-600 bg-yellow-100' : 'text-green-600 bg-green-100'])
                    }, [
                      (absence.open)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Open"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_29, "Closed"))
                    ], 2)
                  ]),
                  _createElementVNode("td", _hoisted_30, [
                    _createVNode(_component_app_button, {
                      onClick: ($event: any) => (_ctx.OnClickEditAbsence(absence)),
                      type: "green",
                      padding: "small",
                      class: _normalizeClass(['mr-1']),
                      title: "Edit absence"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_PencilIcon, { class: "h-5 w-5" })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_app_button, {
                      onClick: ($event: any) => (_ctx.OnClickDeleteAbsence(absence.id)),
                      type: "red",
                      padding: "small",
                      class: _normalizeClass(['mr-1']),
                      title: "Delete absence"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_XIcon, { class: "h-5 w-5" })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}